(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;

  function hexToRgb(hex) {
    var h = String(hex || '').replace('#', '').trim();
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    if (!/^[0-9a-f]{6}$/i.test(h)) return null;
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }
  function luminance(hex) {
    var rgb = hexToRgb(hex);
    if (!rgb) return 0.5;
    var c = rgb.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function inkFor(fg) { return luminance(fg) > 0.4 ? 'light' : 'dark'; }
  function defaultFg(bg) { return luminance(bg) > 0.35 ? '#2A1A14' : '#FFFFFF'; }

  function setColours(bg, fg) {
    root.style.setProperty('--bg', bg);
    root.style.setProperty('--fg', fg);
    body.setAttribute('data-ink', inkFor(fg));
  }

  // Initial ink (logo colour) from whatever page colour CSS set.
  (function () {
    var cs = getComputedStyle(root);
    var fg = cs.getPropertyValue('--fg').trim();
    if (fg) body.setAttribute('data-ink', inkFor(fg));
  })();

  // ---------- Cart count ----------
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      })
      .catch(function () {});
  }

  // ---------- Shop ----------
  var shop = document.querySelector('[data-plowl-shop]');
  if (shop) initShop(shop);

  function initShop(el) {
    var dataEl = el.querySelector('[data-plowl-data]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cols = data.collections || [];
    if (!cols.length) return;

    var bands = Array.prototype.slice.call(el.querySelectorAll('[data-band]'));
    var q = function (s) { return el.querySelector(s); };
    var track = q('[data-track]'), soon = q('[data-soon]'), carousel = q('[data-carousel]');
    var dots = q('[data-dots]'), count = q('[data-count]');
    var kicker = q('[data-kicker]'), nameEl = q('[data-name]'), lineEl = q('[data-line]');
    var priceEl = q('[data-price]'), stockEl = q('[data-stock]'), pills = q('[data-pills]');
    var variantsEl = q('[data-variants]'), optionsLabel = q('[data-options-label]'), optionsWrap = q('[data-options-wrap]');
    var addBtn = q('[data-add]'), msg = q('[data-msg]');
    var qtyWrap = q('[data-qty-wrap]'), qtyEl = q('[data-qty]'), variantsLabel = q('[data-variants-label]');
    var descAbove = q('[data-desc-above]'), descBelow = q('[data-desc-below]');
    function renderDesc(p, v) {
      [descAbove, descBelow].forEach(function (d) { if (d) { d.hidden = true; d.innerHTML = ''; } });
      var html = (v && v.desc) || (p && p.desc) || '';
      var target = data.descPos === 'above' ? descAbove : descBelow;
      if (!p || !html || !target) return;
      target.innerHTML = '<p class="p-small">Description</p><div class="p-desc__body">' + html + '</div>';
      target.hidden = false;
    }

    var state = { cat: 0, picks: {}, variant: {}, slide: 0, qty: 1 };
    var pool = data.pool && data.pool.size > 0 ? data.pool : null;
    var sectionId = el.getAttribute('data-section-id');
    function poolUnits(v) {
      if (!pool || !v || !v.items) return 0;
      return v.items.reduce(function (a, it) { return a + (pool.ids.indexOf(it.id) > -1 ? it.n : 0); }, 0);
    }
    function maxQtyFor(v) {
      var u = poolUnits(v);
      if (!u) return 10;
      return Math.floor(Math.min(pool.max > 0 ? pool.max : Infinity, pool.left) / u);
    }
    function setQty(n) {
      var cap = Math.max(1, Math.min(10, maxQtyFor(current().variant)));
      state.qty = Math.max(1, Math.min(cap, n));
      if (qtyEl) qtyEl.textContent = state.qty;
    }

    function current() {
      var col = cols[state.cat];
      var list = col.products || [];
      var i = Math.min(state.picks[state.cat] || 0, Math.max(list.length - 1, 0));
      var p = list[i] || null;
      var v = null;
      if (p && p.variants.length) {
        var vi = state.variant[p.url];
        if (vi == null) {
          vi = 0;
          for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].available) { vi = k; break; } }
        }
        v = p.variants[Math.min(vi, p.variants.length - 1)];
      }
      return { col: col, list: list, index: i, product: p, variant: v };
    }

    function isPre(v) {
      return !!(v && v.items && v.items.length && v.items.every(function (it) { return it.plan; }));
    }

    function lineItems(v, qty) {
      return (v.items || [{ id: v.id, n: 1, plan: v.plan }]).map(function (it) {
        var o = { id: it.id, quantity: it.n * qty };
        if (it.plan) o.selling_plan = it.plan;
        return o;
      });
    }

    function stockText(v) {
      if (!v) return '';
      if (!v.available) return 'Sold out';
      if (isPre(v) && poolUnits(v)) return 'Pre-order · ' + pool.left + ' of ' + pool.size + ' left';
      if (isPre(v)) return 'Pre-order' + (v.managed && v.qty > 0 && v.qty < 10 ? ' · ' + v.qty + ' left' : '');
      if (v.managed && v.qty > 0) return v.qty + ' left';
      if (v.managed && v.qty <= 0) return 'Pre-order';
      return '';
    }

    function renderCarousel(p) {
      var imgs = (p && p.images) || [];
      track.innerHTML = '';
      dots.innerHTML = '';
      soon.hidden = imgs.length > 0;
      carousel.classList.toggle('is-single', imgs.length < 2);
      imgs.forEach(function (img, i) {
        var im = document.createElement('img');
        im.src = img.src; im.alt = img.alt || ''; im.loading = i === 0 ? 'eager' : 'lazy';
        im.setAttribute('aria-hidden', i === state.slide ? 'false' : 'true');
        track.appendChild(im);
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.setAttribute('aria-current', i === state.slide ? 'true' : 'false');
        b.innerHTML = '<span></span>';
        b.addEventListener('click', function () { goSlide(i); });
        dots.appendChild(b);
      });
      track.style.transform = 'translateX(' + (-100 * state.slide) + '%)';
      count.textContent = imgs.length ? (state.slide + 1) + ' / ' + imgs.length : '';
    }

    function goSlide(i) {
      var p = current().product;
      var n = (p && p.images.length) || 0;
      if (!n) return;
      state.slide = (i + n) % n;
      track.style.transform = 'translateX(' + (-100 * state.slide) + '%)';
      count.textContent = (state.slide + 1) + ' / ' + n;
      Array.prototype.forEach.call(dots.children, function (b, k) { b.setAttribute('aria-current', k === state.slide ? 'true' : 'false'); });
      Array.prototype.forEach.call(track.children, function (im, k) { im.setAttribute('aria-hidden', k === state.slide ? 'false' : 'true'); });
    }

    function render() {
      var c = current();
      var col = c.col, p = c.product, v = c.variant;
      var bg = (p && p.bg) || col.bg || '#8C9A3C';
      var fg = (p && p.fg) || defaultFg(bg);
      setColours(bg, fg);

      bands.forEach(function (b, i) {
        var open = i === state.cat;
        b.classList.toggle('is-open', open);
        b.setAttribute('aria-selected', open ? 'true' : 'false');
        var first = (cols[i].products || [])[0];
        var bandBg = (first && first.bg) || cols[i].bg || '#8C9A3C';
        b.style.setProperty('--band', bandBg);
        b.style.setProperty('--band-ink', (first && first.fg) || defaultFg(bandBg));
        b.style.boxShadow = (!open && bandBg.toLowerCase() === bg.toLowerCase()) ? 'inset 0 0 0 1px ' + fg : 'none';
      });

      kicker.textContent = col.kicker || col.name;
      msg.textContent = '';
      renderDesc(p, v);
      var off = col.mode === 'off' && !isPre(v);
      setQty(state.qty);
      if (!p) {
        nameEl.textContent = 'coming soon';
        lineEl.textContent = col.empty || '';
        priceEl.textContent = '';
        stockEl.textContent = '';
        optionsWrap.hidden = true;
        if (qtyWrap) qtyWrap.hidden = true;
        addBtn.hidden = !(off && col.button);
        addBtn.disabled = true;
        addBtn.textContent = col.button || '';
        renderCarousel(null);
        return;
      }
      nameEl.textContent = p.name;
      lineEl.textContent = p.line || '';
      priceEl.textContent = v ? v.price : '';
      stockEl.textContent = stockText(v);
      addBtn.hidden = false;
      if (off) {
        addBtn.disabled = true;
        addBtn.textContent = col.button || 'Coming soon';
        if (qtyWrap) qtyWrap.hidden = true;
      } else {
        var poolShort = poolUnits(v) > 0 && maxQtyFor(v) < 1;
        var canBuy = !!(v && v.available) && !poolShort;
        addBtn.disabled = !canBuy;
        addBtn.textContent = poolShort ? (pool.left > 0 ? 'Only ' + pool.left + ' left' : 'Pre-orders full') : !canBuy ? 'Sold out' : (isPre(v) ? 'Pre-order' : (col.mode === 'off' ? 'Add to basket' : (col.button || 'Add to basket')));
        if (qtyWrap) qtyWrap.hidden = !canBuy;
      }

      optionsWrap.hidden = false;
      optionsLabel.textContent = col.optionsLabel || 'Glaze';
      pills.innerHTML = '';
      c.list.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'p-pill';
        b.setAttribute('aria-pressed', i === c.index ? 'true' : 'false');
        var dotBg = item.bg || col.bg || '#8C9A3C';
        b.style.setProperty('--dot', dotBg);
        b.style.setProperty('--ring', dotBg.toLowerCase() === bg.toLowerCase() ? (i === c.index ? bg : fg) : 'transparent');
        b.innerHTML = '<span class="p-pill__dot" aria-hidden="true"></span>';
        b.appendChild(document.createTextNode(item.name));
        b.addEventListener('click', function () { state.picks[state.cat] = i; state.slide = 0; state.qty = 1; render(); });
        pills.appendChild(b);
      });
      pills.hidden = c.list.length < 2;
      if (c.list.length < 2) optionsLabel.textContent = '';

      variantsEl.innerHTML = '';
      variantsEl.hidden = p.variants.length < 2;
      if (variantsLabel) { variantsLabel.hidden = p.variants.length < 2; variantsLabel.textContent = p.sizes ? 'How many' : 'Option'; }
      if (p.variants.length > 1) {
        p.variants.forEach(function (vv, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'p-pill';
          b.disabled = !vv.available;
          b.setAttribute('aria-pressed', vv === v ? 'true' : 'false');
          b.textContent = vv.title + (vv.available ? '' : ' — sold out');
          b.addEventListener('click', function () { state.variant[p.url] = k; state.qty = 1; render(); });
          variantsEl.appendChild(b);
        });
      }
      renderCarousel(p);
    }

    bands.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (state.cat === i) return;
        state.cat = i; state.slide = 0; state.qty = 1; render();
      });
    });
    el.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(state.qty + parseInt(b.getAttribute('data-q'), 10)); });
    });
    q('[data-prev]').addEventListener('click', function () { goSlide(state.slide - 1); });
    q('[data-next]').addEventListener('click', function () { goSlide(state.slide + 1); });

    var tx = null;
    track.parentNode.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    track.parentNode.addEventListener('touchend', function (e) {
      if (tx == null) return;
      var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 40) goSlide(state.slide + (dx < 0 ? 1 : -1));
    });

    addBtn.addEventListener('click', function () {
      var v = current().variant;
      if (!v || !v.available || (current().col.mode === 'off' && !isPre(v))) return;
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      var units = poolUnits(v) * state.qty;
      var check = !units ? Promise.resolve(null) : Promise.all([
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
        sectionId ? fetch(location.pathname + '?sections=' + encodeURIComponent(sectionId)).then(function (r) { return r.json(); }).catch(function () { return null; }) : null
      ]).then(function (res) {
        var cart = res[0], fresh = res[1];
        if (fresh && fresh[sectionId]) {
          try {
            var doc = new DOMParser().parseFromString(fresh[sectionId], 'text/html');
            var d = JSON.parse(doc.querySelector('[data-plowl-data]').textContent);
            if (d.pool) pool.left = d.pool.left;
          } catch (e) {}
        }
        var inCart = (cart.items || []).reduce(function (a, it) { return a + (pool.ids.indexOf(it.variant_id) > -1 && it.selling_plan_allocation ? it.quantity : 0); }, 0);
        if (pool.max > 0 && inCart + units > pool.max) {
          throw { description: 'You can pre-order up to ' + pool.max + ' plowls per order' + (inCart ? ' — you already have ' + inCart + ' in your basket.' : '.') };
        }
        if (inCart + units > pool.left) {
          throw { description: pool.left > 0 ? 'Only ' + pool.left + ' pre-order ' + (pool.left === 1 ? 'place is' : 'places are') + ' left.' : 'Pre-orders are full.' };
        }
      });
      check.then(function () { return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lineItems(v, state.qty) })
      }); })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          msg.innerHTML = 'Added. <a class="p-link" href="/cart">View basket</a>';
          return refreshCartCount();
        })
        .catch(function (err) {
          msg.textContent = (err && (err.description || err.message)) || 'Something went wrong — please try again.';
        })
        .then(function () { addBtn.disabled = false; addBtn.textContent = label; });
    });

    // Open a specific collection via #shop-2 etc.
    var m = location.hash.match(/^#shop-(\d)$/);
    if (m && cols[+m[1] - 1]) state.cat = +m[1] - 1;
    render();
  }

  // ---------- Cart quantity steppers ----------
  document.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      var n = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
      input.value = n;
      input.form.submit();
    });
  });

  // ---------- Newsletter pop-up ----------
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var KEY = 'plowl-popup-seen';
    var days = parseInt(popup.getAttribute('data-days'), 10) || 14;
    var success = popup.querySelector('[data-popup-success]');
    var seen = 0;
    try { seen = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      popup.hidden = false;
      var f = popup.querySelector('input[type="email"], [data-popup-close]');
      if (f) f.focus();
    }
    function close() {
      popup.hidden = true;
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
    if (success || /customer_posted=true/.test(location.search)) {
      open();
    } else if (!seen || Date.now() - seen > days * 864e5) {
      setTimeout(open, 1200);
    }
  }

  // ---------- Password page colour frame ----------
  var gate = document.querySelector('[data-gate]');
  if (gate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var glazes = ['#8C9A3C', '#5E1233', '#2659B1', '#4A2A22', '#EFE9DF'];
    var gi = 0;
    gate.style.setProperty('--gate', glazes[0]);
    setInterval(function () { gi = (gi + 1) % glazes.length; gate.style.setProperty('--gate', glazes[gi]); }, 2600);
  }
})();
